/** Pretraga za Maps ako nemaš gotov link — uključuje opštinu jer ima više naselja „Kovačevac“. */
const MAP_SEARCH_QUERY = 'Moravička 4, Kovačevac, opština Prijepolje, Srbija';

export const CONTACT = {
  phone: '+381643807308',
  phoneDisplay: '+381 64 380 7308',
  // Opciono: REACT_APP_WHATSAPP_URL pri Docker / npm build
  whatsapp:
    process.env.REACT_APP_WHATSAPP_URL ||
    'https://wa.me/381643807308',
  viber: 'viber://chat?number=381643807308',
  instagram: 'https://www.instagram.com/erviin___/',
  instagramHandle: '@erviin___',
  address: 'MORAVIČKA 4, 31304 Kovačevac, opština Prijepolje, Srbija',
  /**
   * Tačna tačka: u Google Maps → Podeli → kopiraj link u REACT_APP_GOOGLE_MAPS_URL (.env),
   * ili zameniti MAP_SEARCH_QUERY iznad.
   */
  googleMapsUrl:
    process.env.REACT_APP_GOOGLE_MAPS_URL ||
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(MAP_SEARCH_QUERY)}`,
};
